import CheckIcon from "@mui/icons-material/CheckRounded";
import { Box, ButtonBase, Stack, Typography } from "@mui/material";
import StatusChip from "@entrilia/shared/components/StatusChip";
import { accessCategoryTagColors, getCategoryTagColor } from "@entrilia/shared/utilities/categoryColor";

const paletteSwatches = Object.entries(accessCategoryTagColors).map(([key, color]) => ({ key, color }));

interface Props {
  categoryName: string;
  value?: string;
  onChange: (tagColor: string) => void;
}

const TagColorPicker = ({ categoryName, value, onChange }: Props) => (
  <Stack spacing={1.5}>
    <Typography variant="subtitle2">Tag Color</Typography>
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {paletteSwatches.map(({ key, color }) => (
        <ButtonBase
          key={key}
          aria-label={key}
          aria-pressed={key === value}
          onClick={() => onChange(key)}
          sx={{ width: 24, height: 24, borderRadius: 1, bgcolor: color, color: "common.white" }}
        >
          {key === value && <CheckIcon />}
        </ButtonBase>
      ))}
    </Box>
    <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
      <Typography color="textSecondary">Tag Preview:</Typography>
      <StatusChip label={categoryName} color={getCategoryTagColor(value)} />
    </Stack>
  </Stack>
);

export default TagColorPicker;
